var __extends =
  (this && this.__extends) ||
  (function () {
    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b
          }) ||
        function (d, b) {
          for (var p in b)
            if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]
        }
      return extendStatics(d, b)
    }
    return function (d, b) {
      if (typeof b !== 'function' && b !== null)
        throw new TypeError(
          'Class extends value ' + String(b) + ' is not a constructor or null'
        )
      extendStatics(d, b)
      function __() {
        this.constructor = d
      }
      d.prototype =
        b === null ? Object.create(b) : ((__.prototype = b.prototype), new __())
    }
  })()
var __spreadArray =
  (this && this.__spreadArray) ||
  function (to, from, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i)
          ar[i] = from[i]
        }
      }
    return to.concat(ar || Array.prototype.slice.call(from))
  }
import React from 'react'
import * as d3 from 'd3-geo'
import DataMapState from './DataMapState'
var DataMap = /** @class */ (function (_super) {
  __extends(DataMap, _super)
  function DataMap(props) {
    var _this = _super.call(this, props) || this
    _this.state = {
      topoJSONfeatures: _this.props.topoData,
    }
    _this.drawPath = path(_this.props.svgWidth, _this.props.svgHeight)
    _this.handleMouseEnterOnState = _this.handleMouseEnterOnState.bind(_this)
    _this.renderDatamapStates = _this.renderDatamapStates.bind(_this)
    return _this
  }
  DataMap.prototype.handleMouseEnterOnState = function (name, value, index) {
    var newData = __spreadArray(
      __spreadArray(
        __spreadArray([], this.state.topoJSONfeatures.slice(0, index), true),
        this.state.topoJSONfeatures.slice(index + 1),
        true
      ),
      [this.state.topoJSONfeatures[index]],
      false
    )
    this.setState({
      topoJSONfeatures: newData,
    })
    this.props.mouseEnterOnState(name, value)
  }
  DataMap.prototype.renderDatamapStates = function () {
    var _this = this
    var _a = this.props,
      colorScale = _a.colorScale,
      noDataColor = _a.noDataColor,
      borderColor = _a.borderColor,
      hoverColor = _a.hoverColor,
      hoverBorderColor = _a.hoverBorderColor
    return this.state.topoJSONfeatures.map(function (feature, index) {
      var stateValue = _this.props.regionData[feature.properties.name]
      var fillColor = !stateValue ? noDataColor : colorScale(stateValue.value)
      return React.createElement(DataMapState, {
        key: feature.id,
        index: index,
        // @ts-ignore
        path: function () {
          return _this.drawPath(feature)
        },
        name: feature.properties.name,
        fillColor: fillColor,
        hoverColor: hoverColor,
        borderColor: borderColor,
        hoverBorderColor: hoverBorderColor,
        mouseEnterOnState: _this.handleMouseEnterOnState,
        value: stateValue,
      })
    })
  }
  DataMap.prototype.render = function () {
    return React.createElement(
      'g',
      {
        onMouseMove: this.props.mouseMoveOnDatamap,
        onMouseEnter: this.props.mouseEnterOnDatamap,
        onMouseLeave: this.props.mouseLeaveDatamap,
      },
      this.renderDatamapStates()
    )
  }
  return DataMap
})(React.Component)
function path(svgWidth, svgHeight) {
  var mapConfig = {
    projection: function _projection(width, height) {
      return d3
        .geoMercator()
        .center([78, 27])
        .scale(width * 1.3)
        .translate([width / 2.5, height / 3])
    },
  }
  var projection = mapConfig.projection(svgWidth, svgHeight)
  return d3.geoPath().projection(projection)
}
export default DataMap
